module.exports = __webpack_public_path__ + "static/media/ic_add-file-gray1.617c371f.svg";